module.exports = __webpack_public_path__ + "static/media/dan.4609cb3c.jpeg";